import { discoveryQueryKeys as e } from "./useDiscoveryQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { discoverApi as n } from "@maat/api-main";
//#region src/discovery/useHappeningTodayQuery.ts
var r = (r = {}, i = {}) => t({
	queryKey: e.happeningToday(r),
	queryFn: () => n.getHappeningToday(r),
	staleTime: 6e4,
	enabled: i.enabled !== !1
});
//#endregion
export { r as useHappeningTodayQuery };
